"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FavoriteEntity;
(function (FavoriteEntity) {
    FavoriteEntity["Brand"] = "Brand";
    FavoriteEntity["Category"] = "Category";
    FavoriteEntity["CompetitorReseller"] = "CompetitorReseller";
    FavoriteEntity["CompetitorStore"] = "CompetitorStore";
    FavoriteEntity["Goal"] = "Goal";
    FavoriteEntity["Mapping"] = "Mapping";
    FavoriteEntity["Product"] = "Product";
    FavoriteEntity["Segment"] = "Segment";
    FavoriteEntity["Zoning"] = "Zoning";
})(FavoriteEntity = exports.FavoriteEntity || (exports.FavoriteEntity = {}));
//# sourceMappingURL=favorite-entity.model.js.map